import { Center, HStack, Stack, Text } from '@chakra-ui/react'

import { FormItem } from 'components'
import useUnregisterDefaultValueField from '../../hooks/useUnregisterDefaultValueField'
import { DefaultValueCommonProps } from '../../types/DefaultValueCommonProps'
import useSetDefaultValueOnNotArrayData from '../../hooks/useSetDefaultValueOnNotArrayData'
import { useEffect } from 'react'

export default function DefaultValueNPS({ formMethods, question }: DefaultValueCommonProps) {
  useUnregisterDefaultValueField({ formMethods })

  useSetDefaultValueOnNotArrayData({ formMethods, question })

  const currentValue = formMethods.watch('default_value') || null

  const npsNumbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

  const handleSelectDefaultNPS = (value: number) => {
    if (currentValue != value) {
      formMethods.setValue('default_value', value)
    } else {
      formMethods.setValue('default_value', '')
    }
  }

  useEffect(() => {
    if (Array.isArray(question.default_value)) {
      formMethods.setValue('default_value', question.default_value[0])
    }
  }, [])

  return (
    <Stack>
      <FormItem label="Valor inicial">
        <HStack>
          {npsNumbers.map((number) => {
            const isSelected = number == currentValue
            return (
              <Center
                key={number}
                className="accessible"
                borderWidth="1px"
                height="25px"
                width="25px"
                rounded="full"
                p={1}
                bg={isSelected ? 'primary' : 'bgContent'}
                borderColor={isSelected ? 'primary' : 'borderColor'}
                color={isSelected ? 'light' : 'dark'}
                _hover={{ bg: 'primary', borderColor: 'primary', color: 'light' }}
                onClick={() => handleSelectDefaultNPS(number)}
              >
                <Text>{number}</Text>
              </Center>
            )
          })}
        </HStack>
      </FormItem>
    </Stack>
  )
}
